module.exports = __webpack_public_path__ + "img/E5854C9E8876ADCAE251E4F5F0686426.e5854c9e.png";